<template>
  <div class="buy-feature">
    <XAlert type="warning"> {{ $t('ti-shi') }}{{ feature.desc.join($t('key-0')) }} </XAlert>
    <div v-if="isUpgradable" class="tip flex mt-[35px]">
      <div class="left">
        <div class="tip-left-title">{{ $t('yan-bi-bu-gou-yong') }}</div>
        <div>
          {{
            $t('ni-huan-ke-yi-tong-guo-tao-can-sheng-ji-zeng-gou-yan-bi-zhe-yang-geng-hua-suano')
          }}
        </div>
      </div>
      <button class="right upgrade-btn cursor-pointer" @click="useUpgradeEquity">
        {{ $t('tao-can-sheng-ji') }}
        <iconpark-icon name="arrowright" class="ml-[3px]"></iconpark-icon>
      </button>
    </div>
    <div class="buy-feature__block">
      <h4 class="buy-feature__block-title">
        {{ $t('yan-bi-tao-can') }}
      </h4>
      <TeamBuy
        v-if="userInfo?.rights_type === USER_LEVEL_KEY.TEAM_LIGHT"
        :picked="pickedPackage"
        :packages="packages"
        :rightsName="rightsName"
        @change="handlePick"
      />
      <PersonalBuy v-else :packages="packages" :picked="pickedPackage" @change="handlePick" />
    </div>
  </div>
</template>

<script setup lang="ts" name="BuyFeature">
import XAlert from '@/components/xAlert/index.vue';
import { getRightsCreditCoinsPackage, type ICreditCoinsPackage } from '~/api';
import { USER_LEVEL_KEY } from '~/api/interface';
import type { RIGHTS_FEATURE } from '~/api/interface/rights';
import { RightsFeature } from '~/constants';
import { useDetector } from '~/hooks/useDetector';
import { useUpgradeEquity } from '../..';
import PersonalBuy from './personal.vue';
import TeamBuy from './team.vue';

const props = withDefaults(
  defineProps<{
    pending: boolean;
    packageInfo?: ICreditCoinsPackage;
    rightsName: string;
    featureType: RIGHTS_FEATURE;
    unitPrice: number;
    days?: number;
  }>(),
  {
    days: 0,
  },
);
const { $t } = useNuxtApp();

const userInfo = useUserInfo();
const { isUpgradable } = useDetector();
const emits = defineEmits(['update:packageInfo', 'update:pending']);
const pickedPackage = ref<ICreditCoinsPackage>();

const handlePick = (item: ICreditCoinsPackage) => {
  pickedPackage.value = item;
  emits('update:packageInfo', item);
};

const coinsPackages = await useAsyncData(async () => {
  emits('update:pending', true);
  const res = await getRightsCreditCoinsPackage({
    many: '1',
    rights_type: userInfo.value!.rights_type,
  });
  emits('update:pending', false);
  return res;
});

handlePick(coinsPackages.data.value!.data![0]);

const packages = computed(() => {
  return coinsPackages.data.value?.data || [];
});

const feature = computed(() => RightsFeature()[props.featureType]);
</script>

<style lang="scss" scoped>
.tip {
  justify-content: space-between;
  padding-left: 10px;
  .tip-left-title {
    color: var(--warning-7);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  .upgrade-btn {
    width: 164px;
    height: 44px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    border: 0;
    background-color: var(--warning-4);
    color: var(--warning-10);
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
  }
}

.buy-feature {
  @apply w-full p-[24px];

  .buy-feature__block-title {
    color: var(--text-1);
    font-weight: 500;
    line-height: 20px;
  }

  &__desc {
    padding-top: 16px;
    color: var(--text-1);
    font-size: 14px;
    line-height: 24px;
    opacity: 0.6;
  }
  &__block {
    margin-top: 30px;
    // column-gap: 20px;
    &--label {
      width: 48px;
      opacity: 0.6;
    }
  }
}
</style>
